import { CheckCircle2 } from "lucide-react";

export const SuccessCard = ({ kind, reference, onReset }) => (
  <div data-testid={`${kind}-success-card`} className="flex flex-col items-start gap-5 border border-emerald-500/30 bg-emerald-500/5 p-8">
    <CheckCircle2 className="h-10 w-10 text-emerald-400" />
    <div>
      <h3 className="font-heading text-2xl font-bold text-white">
        {kind === "employer" ? "Requirement received" : "Registration received"}
      </h3>
      <p className="mt-2 max-w-lg leading-relaxed text-slate-300">
        {kind === "employer"
          ? "Our operations desk will contact your HR team. Log in to the Employer portal to see Instant Matches with verified employees."
          : "Log in to the Employee portal with your mobile number to see Instant Job Matches."}
      </p>
    </div>
    <p className="font-mono text-sm text-slate-400">
      Reference: <span data-testid={`${kind}-success-reference`} className="text-orange-400">{reference}</span>
    </p>
    <div className="flex flex-wrap gap-3">
    <a href={`/${kind}`} data-testid={`${kind}-success-portal-link`} className="bg-orange-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-orange-600">
      {kind === "employer" ? "Open Employer portal" : "See my job matches"}
    </a>
    <button type="button" onClick={onReset} data-testid={`${kind}-success-new-button`}
      className="border border-white/15 px-5 py-2.5 text-sm text-slate-200 transition-colors hover:border-orange-500 hover:text-white">
      Submit another
    </button>
    </div>
  </div>
);
